import React from 'react'
import WatchLaterOutlinedIcon from '@mui/icons-material/WatchLaterOutlined';
import BookmarkBorderOutlinedIcon from '@mui/icons-material/BookmarkBorderOutlined';
import FavoriteBorderOutlinedIcon from '@mui/icons-material/FavoriteBorderOutlined';

const Tutorial = () => {
  return (
    <div>


 
<div class="d-flex justify-content-between container-fluid">  

<div class="col-lg-8 p-0 col-sm-12">
    <video src="https://indianhackerslab.com/video.mov" class="w-100" autoplay="" muted="" loop=""></video>

</div>

<div class="col-lg-4 overflow-y-scroll vh-100 px-3 col-md-4 col-sm-12">


<div className="bg-white d-flex flex-wrap border my-2 shadow rounded">
  <div className="col-md-5 col-12 col-sm-12">
    <video src="https://indianhackerslab.com/video.mov" className="w-100 rounded h-100"></video>
  </div>

  <div className="col-lg-7 col-md-12 col-sm-12 mt-3 mt-lg-0 p-2">
  <h6 className="fw-bold text-start">What is a Brute Force Attack?</h6>
  <p className="text-muted text-start p-0 m-0">
    Brute force attacks are trial-and-error methods used to decode sensitive information like passwords or PINs.
  </p>
  <div className="d-flex gap-5 mt-1">
    <BookmarkBorderOutlinedIcon />
    <WatchLaterOutlinedIcon />
    <FavoriteBorderOutlinedIcon />
  </div>
</div>

  
</div>
<div className="bg-white d-flex flex-wrap border my-2 shadow rounded">
  <div className="col-md-5 col-12 col-sm-12">
    <video src="https://indianhackerslab.com/video.mov" className="w-100 rounded h-100"></video>
  </div>

  <div className="col-md-7 col-12  mt-3 mt-md-0 p-2">
    <h6 className="fw-bold text-start">What is a Brute Force Attack?</h6>
    <p className="text-muted text-start p-0 m-0">
      Brute force attacks are trial-and-error methods used to decode sensitive information like passwords or PINs. 
    </p>
    <div className="d-flex gap-5 mt-1">
      <BookmarkBorderOutlinedIcon/>
      <WatchLaterOutlinedIcon/>
      <FavoriteBorderOutlinedIcon/>
    
      
    </div>

    
  </div>
  
</div>
<div className="bg-white d-flex flex-wrap border my-2 shadow rounded">
  <div className="col-md-5 col-12 col-sm-12">
    <video src="https://indianhackerslab.com/video.mov" className="w-100 rounded h-100"></video>
  </div>

  <div className="col-md-7 col-12  mt-3 mt-md-0 p-2">
    <h6 className="fw-bold text-start">What is a Brute Force Attack?</h6>
    <p className="text-muted text-start p-0 m-0">
      Brute force attacks are trial-and-error methods used to decode sensitive information like passwords or PINs. 
    </p>
    <div className="d-flex gap-5 mt-1">
      <BookmarkBorderOutlinedIcon/>
      <WatchLaterOutlinedIcon/>
      <FavoriteBorderOutlinedIcon/>
    
      
    </div>

    
  </div>
  
</div>
<div className="bg-white d-flex flex-wrap border my-2 shadow rounded">
  <div className="col-md-5 col-12 col-sm-12">
    <video src="https://indianhackerslab.com/video.mov" className="w-100 rounded h-100"></video>
  </div>

  <div className="col-md-7 col-12  mt-3 mt-md-0 p-2">
    <h6 className="fw-bold text-start">What is a Brute Force Attack?</h6>
    <p className="text-muted text-start p-0 m-0">
      Brute force attacks are trial-and-error methods used to decode sensitive information like passwords or PINs. 
    </p>
    <div className="d-flex gap-5 mt-1">
      <BookmarkBorderOutlinedIcon/>
      <WatchLaterOutlinedIcon/>
      <FavoriteBorderOutlinedIcon/>
    
      
    </div>

    
  </div>
  
</div>
<div className="bg-white d-flex flex-wrap border my-2 shadow rounded">
  <div className="col-md-5 col-12 col-sm-12">
    <video src="https://indianhackerslab.com/video.mov" className="w-100 rounded h-100"></video>
  </div>

  <div className="col-md-7 col-12  mt-3 mt-md-0 p-2">
    <h6 className="fw-bold text-start">What is a Brute Force Attack?</h6>
    <p className="text-muted text-start p-0 m-0">
      Brute force attacks are trial-and-error methods used to decode sensitive information like passwords or PINs. 
    </p>
    <div className="d-flex gap-5 mt-1">
      <BookmarkBorderOutlinedIcon/>
      <WatchLaterOutlinedIcon/>
      <FavoriteBorderOutlinedIcon/>
    
      
    </div>

    
  </div>
  
</div>
<div className="bg-white d-flex flex-wrap border my-2 shadow rounded">
  <div className="col-md-5 col-12 col-sm-12">
    <video src="https://indianhackerslab.com/video.mov" className="w-100 rounded h-100"></video>
  </div>

  <div className="col-md-7 col-12  mt-3 mt-md-0 p-2">
    <h6 className="fw-bold text-start">What is a Brute Force Attack?</h6>
    <p className="text-muted text-start p-0 m-0">
      Brute force attacks are trial-and-error methods used to decode sensitive information like passwords or PINs. 
    </p>
    <div className="d-flex gap-5 mt-1">
      <BookmarkBorderOutlinedIcon/>
      <WatchLaterOutlinedIcon/>
      <FavoriteBorderOutlinedIcon/>
    
      
    </div>

    
  </div>
  
</div>
<div className="bg-white d-flex flex-wrap border my-2 shadow rounded">
  <div className="col-md-5 col-12 col-sm-12">
    <video src="https://indianhackerslab.com/video.mov" className="w-100 rounded h-100"></video>
  </div>

  <div className="col-md-7 col-12  mt-3 mt-md-0 p-2">
    <h6 className="fw-bold text-start">What is a Brute Force Attack?</h6>
    <p className="text-muted text-start p-0 m-0">
      Brute force attacks are trial-and-error methods used to decode sensitive information like passwords or PINs. 
    </p>
    <div className="d-flex gap-5 mt-1">
      <BookmarkBorderOutlinedIcon/>
      <WatchLaterOutlinedIcon/>
      <FavoriteBorderOutlinedIcon/>
    
      
    </div>

    
  </div>
  
</div>
<div className="bg-white d-flex flex-wrap border my-2 shadow rounded">
  <div className="col-md-5 col-12 col-sm-12">
    <video src="https://indianhackerslab.com/video.mov" className="w-100 rounded h-100"></video>
  </div>

  <div className="col-md-7 col-12  mt-3 mt-md-0 p-2">
    <h6 className="fw-bold text-start">What is a Brute Force Attack?</h6>
    <p className="text-muted text-start p-0 m-0">
      Brute force attacks are trial-and-error methods used to decode sensitive information like passwords or PINs. 
    </p>
    <div className="d-flex gap-5 mt-1">
      <BookmarkBorderOutlinedIcon/>
      <WatchLaterOutlinedIcon/>
      <FavoriteBorderOutlinedIcon/>
    
      
    </div>

    
  </div>
  
</div>
<div className="bg-white d-flex flex-wrap border my-2 shadow rounded">
  <div className="col-md-5 col-12 col-sm-12">
    <video src="https://indianhackerslab.com/video.mov" className="w-100 rounded h-100"></video>
  </div>

  <div className="col-md-7 col-12  mt-3 mt-md-0 p-2">
    <h6 className="fw-bold text-start">What is a Brute Force Attack?</h6>
    <p className="text-muted text-start p-0 m-0">
      Brute force attacks are trial-and-error methods used to decode sensitive information like passwords or PINs. 
    </p>
    <div className="d-flex gap-5 mt-1">
      <BookmarkBorderOutlinedIcon/>
      <WatchLaterOutlinedIcon/>
      <FavoriteBorderOutlinedIcon/>
    
      
    </div>

    
  </div>
  
</div>
<div className="bg-white d-flex flex-wrap border my-2 shadow rounded">
  <div className="col-md-5 col-12 col-sm-12">
    <video src="https://indianhackerslab.com/video.mov" className="w-100 rounded h-100"></video>
  </div>

  <div className="col-md-7 col-12  mt-3 mt-md-0 p-2">
    <h6 className="fw-bold text-start">What is a Brute Force Attack?</h6>
    <p className="text-muted text-start p-0 m-0">
      Brute force attacks are trial-and-error methods used to decode sensitive information like passwords or PINs. 
    </p>
    <div className="d-flex gap-5 mt-1">
      <BookmarkBorderOutlinedIcon/>
      <WatchLaterOutlinedIcon/>
      <FavoriteBorderOutlinedIcon/>
    
      
    </div>

    
  </div>
  
</div>


































</div>

</div>
    </div>
  )
}

export default Tutorial